/*  MUI  */
import { Box } from '@mui/material';

/*  Components  */
import { ContractCalendar } from 'application/Home/Admin/Contracts/Pages/ContractCalendar';

/* NPM */
import { startOfQuarter } from 'date-fns';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/* Internal Components */
import { ContractSectionTitle } from './ContractSectionTitle';

export const ContractBigCalendars = ({ contracts, startDate }) => {
    const { t } = useTranslation();
    const startOfQuarterDate = new Date(startOfQuarter(startDate));

    return (
        <Box
            marginBottom="64px"
            marginTop="64px"
            data-testid="contractBigCalendars"
        >
            <ContractSectionTitle
                title={t('Reports.Contracts.upcomingContracts')}
            />

            <ContractCalendar
                abbreviatedMonthDate
                allEvents={contracts}
                date={startOfQuarterDate}
                forQuarter
                toolbar={false}
            />
        </Box>
    );
};
